<template>
  <validation-observer ref="simpleRules">
    <item-form />
    <image-card />
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ItemForm from '@/views/Admin/About/ItemForm.vue'
import ImageCard from '@/views/Admin/About/elements/ImageCard.vue'

export default {
  name: 'AboutIndex',
  components: {
    ValidationObserver,
    BButton,
    ItemForm,
    ImageCard,
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      itemsForm: false,
      selectItems: null,

    }
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
    saveData() {
      return this.$store.getters['about/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getData()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.getData()
      }
    },
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('about/getDataItem')
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('about/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
